module.exports = __webpack_public_path__ + "static/covers-logo-3781c7ca744714f519dfb3924ed79c37.jpeg";